export default __webpack_public_path__ + "static/logo-6a5fa8d676fb4186f7cd2ea9b470928a.svg";